import loaded from '@/scripts/helpers/loaded';

loaded(() =>{
    document.querySelectorAll('.js--item-slide__block').forEach(function(slideBlock){
        slideBlock.addEventListener('mouseover', function(e){
            e.preventDefault();
            const hasClass = this.classList.contains('active--item');
            const body = this.closest('.wrapper--items--slides');
            const id = this.getAttribute('data-id');
            const image = document.querySelector('.item--background__slides__parent[data-id="' + id + '"]');

            if(!hasClass){
                if(body){
                    const activeBlock = body.querySelector('.item--slides--block.active--item');
                    if(activeBlock) activeBlock.classList.remove('active--item');
                }
                this.classList.add('active--item');
                
                document.querySelectorAll('.item--background__slides__parent').forEach(parent => 
                    parent.classList.remove('active--item')
                );
                
                if(image) image.classList.add('active--item');
            }
        });
    });
});
